import { FC } from 'react'

import styled from 'styled-components'

import { ReferralUser } from 'src/Redux/referral-process/referralList'
import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'
import dayjs from 'src/Helpers/dayjs'
import { formatDate } from 'src/Constants/formatDate'

import { EmptyListMessage } from '../../EmptyListMessage'

import { RewardsDetailsItem } from './RewardsDetailsItem/RewardsDetailsItem'

const List = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  list-style: none;
  padding: 0;
`

const Divider = styled.div<{
  $isLast?: boolean
}>`
  display: ${({ $isLast }) => ($isLast ? 'none' : 'block')};
  border-bottom: 1px dashed ${({ theme }) => theme.color.lightGrey};
  margin-top: 16px;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    display: none;
  }
`

const ItemWrapper = styled.div`
  width: 100%;
  position: relative;
`

const DateWrapper = styled.div`
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  font-family: Segoe UI;
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  width: 100%;
  @media (min-width: ${MAX_MOBILE_WIDTH}) {
    display: none;
  }
`

interface RewardsListProps {
  referralList: ReferralUser[]
}

export const RewardsList: FC<RewardsListProps> = ({ referralList }) => {
  if (!referralList || referralList.length === 0) {
    return <EmptyListMessage />
  }

  return (
    <List>
      {referralList?.map((item) => (
        <ItemWrapper key={item.email}>
          <DateWrapper>
            {dayjs(item.createdAt).format(formatDate.formatDateMonthFull)}
          </DateWrapper>
          <RewardsDetailsItem
            name={`${item.firstName || ''} ${item.lastName || ''}`}
            date={item.createdAt}
            email={item.email}
            status={item.status}
            bonus={Number(item.amount)}
          />
          <Divider
            $isLast={referralList.indexOf(item) === referralList.length - 1}
          />
        </ItemWrapper>
      ))}
    </List>
  )
}
